import React from 'react';

import { type BaseCurrencyType } from '@pkg/types';
import { clamp } from '@pkg/utils';

import { useBaseCurrencyStore, useExchangeRatesStore } from '@app/store/zustand';

import { CurrencyAvatar } from '../CurrencyAvatar';

import { Item, NativePrice, StyledCartPrice, UsdPrice } from './CartPrice.style';
import { tokens } from './CartPrice.tokens';

export interface CartPriceProps {
    currency?: BaseCurrencyType;
    price?: number;
    size?: number;
}

export function CartPrice({ currency = 'usd', price = 0, size = tokens.nativePriceSize }: CartPriceProps) {
    const formatCurrency = useBaseCurrencyStore((state) => state.formatCurrency);
    const convertCurrency = useExchangeRatesStore((state) => state.convertCurrency);

    const convertedUsd = convertCurrency(currency, 'usd', price);
    const safeSize = clamp(14, size, 140);

    const iconMarkup = currency === 'usd' ? null : <CurrencyAvatar currency={currency} size={safeSize} />;

    const usdMarkup =
        currency === 'usd' ? null : (
            <Item>
                <UsdPrice>{formatCurrency('usd', convertedUsd)}</UsdPrice>
            </Item>
        );

    return (
        <StyledCartPrice $size={safeSize}>
            <Item>
                {iconMarkup}
                <NativePrice>{formatCurrency(currency, price)}</NativePrice>
            </Item>

            {usdMarkup}
        </StyledCartPrice>
    );
}
